import React from "react";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import { AddToolTip } from "../../../components";
// import "./loadDef.css";

function AggregateKeys({ values, setselectFields }) {
  return (
    <div style={{ width: "30%", height: "31rem", marginBottom: "10rem" }}>
      <p style={{ fontSize: "16px", width: "220px" }}>
        Aggregate keys{" "}
        <span
          style={{ fontSize: "14px" }}
          className=" ml-1 click-to-select-aggkeys"
          onClick={() => {
            setselectFields(true);
          }}
        >
          {" "}
          Click to select{" "}
        </span>{" "}
      </p>
      <Card
        className="mb-5 px-4 py-2 w-100 h-100 rounded list-item-group"
        style={{ overflowY: "scroll" }}
      >
        {values.aggregationEntites.map((element) => {
          return (
            <div className="border-bottom">
              <p style={{ fontSize: "12px" }} className="py-2 m-0">
                {element.fieldName[0] == "/" ? (
                  <AddToolTip name={element.fieldName.substring(1)} />
                ) : (
                  <AddToolTip name={element.fieldName} />
                )}
              </p>
            </div>
          );
        })}
      </Card>
    </div>
  );
}

export default AggregateKeys;
